import React from 'react';
import './CommunitySection.css';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const CommunitySection: React.FC = () => {
  const { ref: sectionRef, style: sectionStyle } = useScrollAnimation<HTMLElement>({ delay: 0.1 });
  const { ref: cardRef, style: cardStyle } = useScrollAnimation<HTMLDivElement>({ delay: 0.2 });
  const { ref: labelRef, style: labelStyle } = useScrollAnimation<HTMLSpanElement>({ delay: 0.3 });
  const { ref: titleRef, style: titleStyle } = useScrollAnimation<HTMLHeadingElement>({ delay: 0.4 });
  const { ref: textRef, style: textStyle } = useScrollAnimation<HTMLParagraphElement>({ delay: 0.5 });
  const { ref: milestoneRef, style: milestoneStyle } = useScrollAnimation<HTMLDivElement>({ delay: 0.6 });
  const { ref: benefitsRef, style: benefitsStyle } = useScrollAnimation<HTMLDivElement>({ delay: 0.7 });
  const { ref: ctaRef, style: ctaStyle } = useScrollAnimation<HTMLDivElement>({ delay: 0.8 });

  return (
    <section className="community-section" id="community" ref={sectionRef} style={sectionStyle}>
      <div className="community-container">
        <div className="community-card" ref={cardRef} style={cardStyle}>
          <div className="card-glow"></div>
          <div className="card-content">
            <span className="section-label" ref={labelRef} style={labelStyle}>Community</span>
            <h2 className="community-title" ref={titleRef} style={titleStyle}>
              Building <span className="highlight">Together</span>
            </h2>
            
            <p className="community-text" ref={textRef} style={textStyle}>
              When we reach our goals, I'll create an exclusive community for all Boost+ holders. 
              This will be our space to connect, share ideas, and grow together.
            </p>

            <div className="community-milestone" ref={milestoneRef} style={milestoneStyle}>
              <h3>Next Milestone: X Premium</h3>
              <p>
                Once we have enough support, I'll get X Premium to better engage with our community 
                and provide more value to all holders.
              </p>
            </div>

            <div className="community-benefits" ref={benefitsRef} style={benefitsStyle}>
              <h3>Community Benefits:</h3>
              <ul>
                <li>
                  <span className="check-icon">✓</span>
                  Direct access to project updates
                </li>
                <li>
                  <span className="check-icon">✓</span>
                  Early access to new developments
                </li>
                <li>
                  <span className="check-icon">✓</span>
                  Exclusive holder discussions
                </li>
                <li>
                  <span className="check-icon">✓</span>
                  Community-driven initiatives
                </li>
              </ul>
            </div>

            <div className="community-cta" ref={ctaRef} style={ctaStyle}>
              <p className="cta-text">Join the journey and be part of something special.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommunitySection;